module.exports = __webpack_public_path__ + "static/map-241388355197d957aa4a940511804154.mp4";